module.exports = __webpack_public_path__ + "img/34.d34a25a6.jpg";